import React from 'react';
import Btn, { BtnModifier } from '../../../../Btn';
import { TooltipPlacement } from '../../../../../atoms/Tooltip';
import { Icons } from '../../../../../atoms/SVG';

type CategoryListItemProps = {
  title: string;
  hexColor?: string;
  remove?: () => void;
  removeText?: string;
};
export function CategoryListItem({ title, hexColor, remove, removeText }: CategoryListItemProps) {
  return (
    <div className="category-list-item" style={{ borderLeftColor: hexColor }}>
      <span className="category-list-item__title">{title}</span>
      {remove && (
        <Btn
          modifier={[BtnModifier.MINOR_ACTION, BtnModifier.TRANSPARENT]}
          svgSpriteId={Icons.DELETE_X_SMALL}
          type="button"
          text={removeText}
          titleText={removeText}
          hiddenText
          tooltipPlacement={TooltipPlacement.LEFT}
          onClick={remove}
        />
      )}
    </div>
  );
}
